const alphabeticalSort = (a, b) => a.localeCompare(b)

export default alphabeticalSort
